import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/bid-ask-spread-calculator',
  component: () => import('../../routes/BidAskSpread.svelte'),
  card: {
    id: 'bid-ask-spread',
    title: 'Bid-Ask Spread Calculator',
    description: 'Calculate the bid-ask spread, total transaction cost, and liquidity classification for any security.',
    icon: 'swap_horiz',
    iconBgClass: 'bg-teal-50',
    iconTextClass: 'text-teal-600',
    href: '/bid-ask-spread-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Bid-Ask Spread Calculator – Measure Market Liquidity & Trading Costs',
    description: 'Free bid-ask spread calculator computes spread cost, mid-price, and liquidity classification for stocks, forex, and other securities. Understand your true execution cost.',
  },
};

export default meta;
